import Dashboard from "./Dashboard"
const UnauthorizedApp = {
    Dashboard
}

export default UnauthorizedApp